import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-issue',
	path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
	query: ['oldIssueView?'],
	exact: true,
};
